import { render, staticRenderFns } from "./AppointmentButtonCallLpu.vue?vue&type=template&id=932fca56&"
import script from "./AppointmentButtonCallLpu.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AppointmentButtonCallLpu.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('932fca56')) {
      api.createRecord('932fca56', component.options)
    } else {
      api.reload('932fca56', component.options)
    }
    module.hot.accept("./AppointmentButtonCallLpu.vue?vue&type=template&id=932fca56&", function () {
      api.rerender('932fca56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/AppointmentButtonCallLpu/AppointmentButtonCallLpu.vue"
export default component.exports